import { render } from "./TeamingTiptapDecision.vue?vue&type=template&id=23b48608"
import script from "./TeamingTiptapDecision.vue?vue&type=script&lang=js"
export * from "./TeamingTiptapDecision.vue?vue&type=script&lang=js"

import "./TeamingTiptapDecision.vue?vue&type=style&index=0&id=23b48608&lang=scss"
script.render = render

export default script